import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import './app-modules.css';
import 'brace/mode/graphqlschema';
import 'brace/theme/monokai';
import copy from 'copy-to-clipboard';
import RoutingService from '../../services/RoutingService';
import HeaderBreadcrumb from '../../components/header-breadcrumb/HeaderBreadcrumb';
import CodeEditor from '../../components/code-editor/CodeEditor';
import RESTService from '../../services/RESTService';
import { view, store } from 'react-easy-state';
import _ from 'lodash';
import InputField from '../../components/input-field/InputField';
import Dropdown from '../../components/dropdown/Dropdown';
import CommonService from '../../services/CommonService';
import GQLPanel from '../entities-panel/GQLPanel/GQLPanel';
import MigrationModal from './migration-modal/MigrationModal';
const connect = new RESTService();
const RS = new RoutingService();
const CS = new CommonService();

class AppModules extends ComponentHelper {
	appData = store({
		fullConfig: null,
		currentNode: '',
		nodes: [],
		allKeys: [],
		config: '{}',
		showQueryEditor: false,
		query: '',
		newNode: '',
		moveOpen: false,
		validJson: true,
		showNewNode: false,
		confirm: false,
		original: null
	});

	constructor(props) {
		super(props);
		this.data = this.appData;
		this.autoBindAll(this, null, true);
	}

	componentDidMount() {
		this.loadPartialConfig();
	}

	loadPartialConfig(part) {
		let config = RS.getCurrentConfiguration();
		connect
			.getAppConfig({
				_id: config._id,
				name: config.name,
				version: config.version
			})
			.then(res => {
				if (res.data) {
					this.data.fullConfig = res.data;
					let keys = Object.keys(res.data);
					this.data.allKeys = keys;
					let validKeys = [];
					_.forEach(keys, key => {
						if (typeof res.data[key] === 'object' && key !== 'endpoints') {
							validKeys.push(key);
						}
					});
					this.data.original = null;
					this.data.confirm = false;
					this.data.nodes = validKeys;
					this.data.currentNode = validKeys.indexOf(part) >= 0 ? part : validKeys[0];
					this.data.config = JSON.stringify(res.data[this.data.currentNode], undefined, 2);
				}
			})
			.catch(err => {
				RS.smartError(err);
			});
	}

	checkForErrors = () => {
		setTimeout(() => {
			if (typeof this.editor.getModel().getAllDecorations === 'function') {
				let decorations = this.editor.getModel().getAllDecorations();
				let error = decorations
					.filter(decorations => {
						return decorations.options.className === 'redsquiggly';
					})
					.map(e => e);
				this.observe(() => {
					this.data.validJson = error.length <= 0;
				});
			}
		}, 1500);
	};

	handleConfigChange(newValue) {
		let error = [];
		if (this.data.editor && typeof this.editor.getModel().getAllDecorations === 'function') {
			let decorations = this.editor.getModel().getAllDecorations();
			error = decorations
				.filter(decorations => {
					return decorations.options.className === 'redsquiggly';
				})
				.map(e => e);
		}
		this.observe(() => {
			this.data.config = newValue;
			this.data.validJson = error.length <= 0;
		});
		this.checkForErrors();
	}

	downloadConfig = () => {
		let config = RS.getCurrentConfiguration();
		connect
			.getAppConfig({
				_id: config._id,
				name: config.name,
				version: config.version
			})
			.then(res => {
				CS.downloadObjectAsJson(res.data, 'app-config');
			})
			.catch(err => {
				RS.smartError(err);
			});
	};

	saveConfig = skipDiff => {
		if (this.data.confirm || skipDiff === true) {
			return connect
				.updateAppConfigSegment(this.data.currentNode, JSON.parse(this.data.config), this.data.fullConfig.name)
				.then(res => {
					RS.showSuccess();
					RS.setCurrentConfiguration(res.data);
					this.data.original = null;
					this.data.confirm = false;
				})
				.catch(err => {
					RS.smartError(err);
					this.data.original = null;
					this.data.confirm = false;
				});
		} else {
			let config = RS.getCurrentConfiguration();
			this.data.original = JSON.stringify(config[this.data.currentNode], undefined, 2);
			this.data.confirm = true;
		}
	};

	changeNode(newVal) {
		this.data.currentNode = newVal.value;
		this.loadPartialConfig(this.data.currentNode);
	}

	getAppNodes() {
		if (this.data.nodes) {
			let options = [];
			_.forEach(this.data.nodes, node => {
				options.push({
					label: node,
					value: node
				});
			});
			return options;
		}
		return [];
	}

	newNodeChange(evt) {
		this.data.newNode = evt.target.value;
	}

	showNodeInput() {
		this.data.showNewNode = true;
	}

	addNode() {
		let noDupe = true;
		_.forEach(this.data.allKeys, key => {
			if (key.toLowerCase() === this.data.newNode.toLowerCase()) {
				noDupe = false;
			}
		});
		if (this.data.newNode.length > 0 && noDupe) {
			this.data.currentNode = this.data.newNode;
			this.data.config = '{}';
			this.saveConfig(true).then(() => {
				this.data.showNewNode = false;
				this.loadPartialConfig(this.data.newNode);
				this.data.newNode = '';
			});
		}
	}

	openGraphEditor() {
		this.data.showQueryEditor = true;
	}

	closeGraphEditor() {
		this.data.showQueryEditor = false;
	}

	handleGQLChange(value) {
		this.data.query = value;
	}

	copyGraphQuery() {
		copy(JSON.stringify(this.data.query));
		RS.showSuccess('Query copied to clipboard');
		this.closeGraphEditor();
	}

	openMoveModal() {
		this.data.moveOpen = true;
	}

	closeMove() {
		this.data.moveOpen = false;
	}

	onMoveNode(env) {
		return connect
			.migrateAppConfigNode(this.data.currentNode, JSON.parse(this.data.config), this.data.fullConfig.name, RS.getCurrentTenant(), env)
			.then(res => {
				RS.showSuccess('Migration Complete!');
				this.data.moveOpen = false;
			})
			.catch(err => {
				RS.smartError(err);
			});
	}

	render() {
		let { currentNode, config, validJson, showNewNode, newNode, original, showQueryEditor, moveOpen } = this.data;
		return (
			<div className="app-modules-view animated fadeIn">
				<div className="hbox vcenter">
					<HeaderBreadcrumb currentPage="App Configuration Editor" />
					<button className="btn m-r-20" onClick={this.openMoveModal}>
						Move Current Node
					</button>
					<button className="btn m-r-20" onClick={this.openGraphEditor}>
						Compose GQL
					</button>
					<button className="btn m-r-20" onClick={this.downloadConfig}>
						Download Config
					</button>
					<button className="btn primary" onClick={this.saveConfig} disabled={!validJson}>
						{original ? 'Confirm' : 'Save'}
					</button>
				</div>
				<div className="controls hbox vcenter">
					<Dropdown
						className="node-picker"
						label="App Config Node"
						value={currentNode}
						handleChange={this.changeNode}
						name="authType"
						options={this.getAppNodes()}
					/>
					<button className="btn primary square vbox hcenter vcenter" title="Add Node" onClick={this.showNodeInput}>
						<i className="mdi mdi-plus" />
					</button>
					{showNewNode && (
						<div className="hbox vcenter animated fadeInLeft">
							<InputField type="text" label="Enter New Node" placeholder="Enter New Node" value={newNode} handleChange={this.newNodeChange} />
							<button className="btn primary square vbox hcenter vcenter" title="Add Node" onClick={this.addNode}>
								<i className="mdi mdi-plus" />
							</button>
						</div>
					)}
				</div>
				<div className="config-editor-placeholder">
					<CodeEditor
						className="editor-content"
						language="json"
						value={config}
						original={original}
						onChange={this.handleConfigChange}
						registerTo={this}
					/>
				</div>
				{showQueryEditor && (
					<div className="graph-editor-wrapper vbox vcenter hcenter">
						<div className="graph-query-editor animated fadeInUp">
							<div className="hbox vcenter">
								<h1 className="grow-1">Query Editor</h1> <i className="mdi mdi-close" onClick={this.closeGraphEditor} />
							</div>
							<h2>Write your query here and click copy and it will format it to the proper JSON shape the config requires</h2>
							<GQLPanel onChange={this.handleGQLChange} />
							<div className="btn-ctn">
								<button className="btn primary" onClick={this.copyGraphQuery}>
									Copy
								</button>
							</div>
						</div>
					</div>
				)}
				<MigrationModal onMove={this.onMoveNode} isOpen={moveOpen} title={'TEMP: Move config node to other environment'} onCancel={this.closeMove} />
			</div>
		);
	}
}

export default view(AppModules);



// WEBPACK FOOTER //
// ./src/views/app-modules/AppModules.js